<script>
    import { noteStore, clientStore } from '../../stores';
    import { config } from '../../../scripts/defaultURL';
    import { clearForm, formatPayloadDate } from '../../../scripts/functions';
    import { postData } from '../../../scripts/rest';

    let payload = { 
        client_id: $clientStore.client.id,
        date: formatPayloadDate(new Date()) 
    };

    function closeModal() {
        clearForm('#addNoteModal input, #addNoteModal textarea');
        payload = { 
            client_id: $clientStore.client.id,
            date: formatPayloadDate(new Date())
        };
        document.getElementById('addNoteModal').classList.remove('is-active')
        if (!$noteStore) $noteStore = {};
        $noteStore['todo'] = 'getData'
    }
  
    function save() {
        console.log('payload',payload);
  
        postData(`${config.defaultURL}/notes/add`, payload)
        .catch((error) => console.error('Failed to post note:', error))
        .then((res) => {
            console.log(res)
            closeModal()
        })
    }
</script>

<style>
    .modal-card-title {
        margin-bottom: 0 !important;
    }
</style>
    
<div class="modal" id="addNoteModal">
    <div class="modal-background" />
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">Add Note</p>
            <button on:click={closeModal} class="delete" aria-label="close" />
        </header>
        <section class="modal-card-body">
        <div class="field">
            <!-- svelte-ignore a11y-label-has-associated-control -->
            <label class="label">Date</label>
            <input bind:value={payload.date} class="input" type="date" name="date" placeholder="Enter Date" required />
        </div>
        
        <div class="field">
            <!-- svelte-ignore a11y-label-has-associated-control -->
            <label class="label">Note</label>
            <textarea bind:value={payload.note} class="textarea" name="note" placeholder="Enter Note"></textarea>
        </div>
            <div class="field is-grouped">
            <div class="control">
                <button on:click={save} class="button is-primary">Save</button>
            </div>
            <div class="control">
                <button
                on:click={closeModal}
                class="button is-primary is-light">Cancel</button>
            </div>
            </div>      
        </section>
    </div>
</div>
    